export default __webpack_public_path__ + "49b936b.png";